(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ELEMENT"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["ELEMENT", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["VOCUSTUI"] = factory(require("ELEMENT"), require("Vue"));
	else
		root["VOCUSTUI"] = factory(root["ELEMENT"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5f72__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 